import $ from 'jquery'

var AccessibilityController = {
    CallbackType: {
        ESC: 27,
        TAB: 9,
        SPACE: 32,
        ENTER: 13,
    },

    isMobileDevice: false,

    hasUserTabbed: false,

    SEL_ACCES_MAIN_ITEM: '.accesibilityMainNavFocus',
    SEL_ACCES_FIST_ITEM: '[data-ada-first]',
    SEL_ACCES_LAST_ITEM: '.accesibilityLastItem',
    DIV_ACCES_BTN: '#accessible_version_button',
    CLASS_ACCES_LAST_ITEM: 'accesibilityLastItem',
    CLASS_MODAL_SHOWN: 'accesibility-modal-shown',
    eventCallbacks: {},

    /**
     * Init Accessibility Controller
     * @param  Boolean isMobileDevice are we on mobile?
     * @param  Boolean handleEnter should Accessibility controller handler enter?
     * @return void
     */
    init: function(isMobileDevice, handleEnter) {
        AccessibilityController.isMobileDevice = !!isMobileDevice
        AccessibilityController.handleEnter = !!handleEnter
        this._setTabIndexes()
        this._setKeyboardEvents()
        this._setBindLoop()
        this._hackCSSInterval = setInterval(this._hackCSS.bind(this), 500)
        $(document).focus()
        this.focusOnFirstItem()
    },

    /**
     * Subscribe to accessibility events
     * @return (bool) if subscribed successfully
     */
    subscribeToCallback: function(type, callback) {
        if (!this.eventCallbacks[type]) {
            this.eventCallbacks[type] = []
        }
        this.eventCallbacks[type].push(callback)
        return true
    },

    /**
     * Un-Subscribe to accessibility events
     * @return (bool) if un-subscribed successfully
     */
    unsubscribeFromCallback: function(type, callback) {
        var scope = this
        if (!this.eventCallbacks[type]) {
            return false
        }
        $.each(scope.eventCallbacks[type], function(i) {
            if (scope.eventCallbacks[type][i] === callback) {
                scope.eventCallbacks[type].splice(i, 1)
                return true
            }
        })
        return false
    },

    /**
     * Logic to select and focus on main item on this page.
     */
    focusOnMainNav: function() {
        var $mainItem = $(AccessibilityController.SEL_ACCES_MAIN_ITEM)
        if ($mainItem.length > 0) {
            this.focusElement($mainItem)
        } else if (
            window.parent &&
            window.parent.location.origin == window.location.origin &&
            window.parent == window.top
        ) {
            window.parent.postMessage({ close: true }, window.location.origin)
        }
    },

    clearTabindexes: function($elm) {
        $elm.find(':tabbable').each(function(a) {
            var oldIndex = $(this).attr('tabindex') || 0
            $(this).attr('tabindex', -1)
            if ($(this).hasClass('ada-tabbable') === false) {
                $(this)
                    .attr('data-old-tabindex', oldIndex)
                    .addClass('ada-tabbable')
            }
        })
    },

    resetTabindexes: function($elm) {
        $elm.find('.ada-tabbable').each(function(a) {
            var oldIndex = $(this).attr('data-old-tabindex') || 0
            $(this).attr('tabindex', oldIndex)
        })
    },

    /**
     * Modal Shown
     * Call when a new modal is presented
     * This function will clean up focus to only be that modal
     * @param elementSelector selector of modal
     */
    modalShown: function(elementSelector) {
        if (AccessibilityController.isMobileDevice) return
        var scope = this
        var $modal = $(elementSelector)
        if ($modal.length > 0 && !$modal.hasClass(AccessibilityController.CLASS_MODAL_SHOWN)) {
            var $frame = $modal.find('iframe')
            if ($frame.length > 0) {
                $frame.one('load', function() {
                    scope.clearTabindexes($(document))
                    scope.resetTabindexes($modal)
                    $modal.addClass(AccessibilityController.CLASS_MODAL_SHOWN)
                    scope.focusOnFirstItem($modal)
                })
            } else {
                this.clearTabindexes($(document))
                this.resetTabindexes($modal)
                $modal.addClass(AccessibilityController.CLASS_MODAL_SHOWN)
                this.focusOnFirstItem($modal)
            }
        }
    },

    /**
     * Modal Dismissed
     * Call when a new modal is closed
     * This function will reset app focus
     * @param elementSelector selector of modal
     */
    modalDismissed: function(elementSelector) {
        if (AccessibilityController.isMobileDevice) return
        var $modal = $(elementSelector)

        this.resetTabindexes($(document))
        if ($modal.length > 0 && $modal.hasClass(AccessibilityController.CLASS_MODAL_SHOWN)) {
            this.clearTabindexes($modal)
            $modal.removeClass(AccessibilityController.CLASS_MODAL_SHOWN)
        }
        this.focusOnFirstItem($(document))
    },

    /**
     * Accesibility Looper
     * This will bind to the last tab-able item to reset to the first.
     * The reason behind this is primarily when embeded within the experience
     * but will also make it easer to navigate our experience
     */
    _setBindLoop: function() {
        var $lastItem = $(AccessibilityController.SEL_ACCES_LAST_ITEM)
        if ($lastItem.length == 0) {
            $('body').append(
                '<a href="#' +
                    AccessibilityController.CLASS_ACCES_LAST_ITEM +
                    '" class="' +
                    AccessibilityController.CLASS_ACCES_LAST_ITEM +
                    '" aria-hidden="true" tabIndex="999999" style="opacity:0;">Restart tabbing to start of experience</a>'
            )
        }
    },

    /**
     * Certain items we cannot style but cause compliance exceptions
     * We hack them here
     */
    _hackCSS: function() {
        //hack google maps
        var $gTerms = $('a[href="https://www.google.com/intl/en-US_US/help/terms_maps.html"]')
        if ($gTerms.length > 0) {
            $gTerms.css('background', 'white')
            clearInterval(this._hackCSSInterval)
        }
    },

    getFirstTabbableITem: function() {
        var $items = $('[data-ada-first]:visible')
        if ($items.length == 0) {
            $items = $('[data-ada-first]:visible').find(':tabbable')
        }
        if ($items.length > 0) {
            var $f = $($items[0])
            for (let i = 0; i < $items.length; i++) {
                let $i = $items[i]
                if ($i.tabIndex < $f[0].tabIndex) $f = $($i)
            }
            return AccessibilityController.isMobileDevice ? $(AccessibilityController.DIV_ACCES_BTN) : $f
        }
        return false
    },

    /**
     * Logic to select and focus on first item in page.
     */
    focusOnFirstItem: function($source, $attempt) {
        var $firstItem = this.getFirstTabbableITem()
        $source && $source.length > 0 && $source.blur && $source.blur()
        if ($firstItem && $firstItem.length > 0) {
            this.focusElement($firstItem, !this.hasUserTabbed)
        } else if (!$source && (!$attempt || !$attempt < 5)) {
            var that = this
            $attempt++
            setTimeout(() => {
                that.focusOnFirstItem($source, $attempt)
            }, 250)
        }
    },

    /**
     * Focus on element
     * @param  dom el
     * @param  bool silentFocus
     */
    focusElement: function($el, silentFocus, skipCallFocus) {
        //clean up previous focused items
        $('.keyboard-focused').removeClass('keyboard-focused')
        $('.hidden-focused').removeClass('hidden-focused')
        var $elf = $el.first()
        if (!skipCallFocus) {
            $elf.focus()
        }
        if (silentFocus) {
            //make sure user can't tell the item is focused (mobile, dismissing forms)
            $elf.addClass('hidden-focused')
        } else {
            //add our focus style so user can tell what is focused
            $elf.addClass('keyboard-focused')
        }
    },

    clickElement: function($el, $event) {
        //add disable-accessible-click if element handles enter it's self.
        if (!$el.hasClass('disable-accessible-click')) $el.trigger('click')
    },

    //set tabIndex sequences for all static elements in walking tour
    _setTabIndexes: function() {
        var that = this
        //No longer used.
    },

    /**
     * Apply accesibility callbacks for a specific event.
     * @param type of callbacks
     */
    _applyAccessibilityCallbacks: function(type) {
        var scope = this
        if (scope.eventCallbacks && scope.eventCallbacks[type]) {
            $.each(scope.eventCallbacks[type], function(i) {
                scope.eventCallbacks[type][i]()
            })
        }
    },

    _setKeyboardEvents: function() {
        var scope = this
        $(document).keyup(function(e) {
            var that = e.target
            scope._applyAccessibilityCallbacks(e.keyCode)
            if (e.keyCode === AccessibilityController.CallbackType.TAB) {
                /* TAB */

                //handle keyboard TAB to select and focus element
                if (!scope.hasUserTabbed) scope.hasUserTabbed = true
                if (that && that.className.indexOf(AccessibilityController.CLASS_ACCES_LAST_ITEM) > -1) {
                    scope.focusOnFirstItem(false)
                    return false
                } else {
                    scope.focusElement($(that), false, true)
                }
            } else if (e.keyCode === AccessibilityController.CallbackType.ESC) {
                /* ESC */
                scope.focusOnMainNav()
            } else if (
                AccessibilityController.handleEnter &&
                e.keyCode === AccessibilityController.CallbackType.ENTER
            ) {
                scope.clickElement($(that), e)
            }
        })
    },

    _assignMediaLinks: function(baseIndex) {
        $('#media a.prev-arrow').attr('tabIndex', baseIndex + 1 + '')
        $('#media a.next-arrow').attr('tabIndex', baseIndex + 2 + '')
        $('#media a.module-icon-panos').attr('tabIndex', baseIndex + 3 + '')
        $('#media a.module-icon-photos').attr('tabIndex', baseIndex + 4 + '')
        $('#media a.module-icon-videos').attr('tabIndex', baseIndex + 5 + '')
        $('#media a.close-btn').attr('tabIndex', baseIndex + 6 + '')
    },
}
export default AccessibilityController
